import { updateSession } from '../lib/funnels/functions/v1/default/updateSession'
// -------------------
// To be used for scripts that only run in funnel entry points
// as opposed to shared that runs on every page of every funnel
// -------------------

const SESSION_ID = 'tdMainFunnel'
updateSession(SESSION_ID, 'referrer', document.referrer)
